<template>
  <v-expansion-panel class="accordion-templates">
    <v-expansion-panel-header class="accordion-templates__header">
      {{ group.categoryName }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-expansion-panels v-if="group.children">
        <template v-for="child in groupedTemplateList">
          <accordion-templates-group
            v-if="checkGroupHasTemplates(child)"
            v-bind:key="child.id"
            v-bind:group="child"
            v-bind:selected-templates="selectedTemplates"
            v-on:template-toggle="onTemplateToggle"
          />
        </template>
      </v-expansion-panels>
      <div class="accordion-templates__items">
        <span
          v-for="(template, index) in group.templates"
          v-bind:key="index"
          class="accordion-templates__item"
        >
          <input-checkbox
            v-bind:title="template.name"
            v-bind:name="`template.id`"
            v-bind:value="isTemplateSelected(template.id, template.type)"
            v-on:input="onTemplateToggle(
              template.name,
              template.type,
              template.id,
              template.isSample,
              $event)"
          />
        </span>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import { List } from 'monet';

/**
 * @description Группа шаблонов для аккордеона.
 * @type {Vue}
 */
export default {
  components: {
    InputCheckbox,
  },
  computed: {
    /**
     * @description Создать список сгруппированных шаблонов.
     *
     * @returns {Object[]}
     */
    groupedTemplateList() {
      if (!this.group.children) {
        return [];
      }
      return this.group.children.map((group) => ({
        id: group.id,
        categoryName: group.categoryName,
        templates: group.templates,
        children: group.children,
      }));
    },
  },
  methods: {
    /**
     * @description Проверить, выбран ли шаблон.
     *
     * @param {string} templateId
     * @param {string} templateType
     * @returns {boolean}
     */
    isTemplateSelected(templateId, templateType) {
      return this
        .selectedTemplates
        .exists((template) => template.id.toString() === templateId.toString()
           && template.type === templateType);
    },
    /**
     * @description Обработать выбор/снятие шаблона.
     *
     * @param {string} templateName
     * @param {string} templateId
     * @param {string} templateType
     * @param {boolean} checked
     * @param {boolean} isTemplateSample
     * @returns {void}
     */
    onTemplateToggle(templateName, templateType, templateId, isTemplateSample, checked) {
      this.$emit(
        'template-toggle',
        templateName,
        templateType,
        templateId,
        isTemplateSample,
        checked,
      );
    },
    /**
     * @description Проверить категорию на наличие шаблонов.
     *
     * @param {Object} group Сгруппированая категория шаблонов.
     * @returns {boolean}
     */
    checkGroupHasTemplates(group) {
      return !!group.templates?.length;
    },
  },
  name: 'AccordionTemplatesGroup',
  props: {
    /**
     * @description Список сгруппированных шаблонов.
     * @type {Object}
     */
    group: { required: true, type: Object },
    /**
     * @description Выбранные шаблоны.
     * @type {List<SelectTemplate>}
     */
    selectedTemplates: { default: () => List(), type: Object },
  },
};
</script>

<style scoped lang="scss">
.accordion-templates {
  &__header {
    display: flex;
    align-items: center;
    padding-block: 14px;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    list-style: none;
    padding-left: 20px !important;
  }
  &__item {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
  }
}

@media screen and (max-width: 480px) {
  .accordion-templates {
    &__item {
      border-bottom: 1px solid #90a0b7;
      padding: 0 0 10px 0;

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
